import {call, put, takeLatest} from 'redux-saga/effects';
import * as actionTypes from './actions';
import axios from '../../config/axios';
import {updatePayment} from 'api/payments.api';
import {API_URL} from "constants/index";

function* getPaymentData(action) {
  try {

    const response = yield axios({
      method: 'GET',
      url: `/deal/${action.id}/payments/${action.scheduleId}`,
    })

    if (response?.status === 200) {
      const { data } = response.data;
      yield put({
        type: actionTypes.GET_PAYMENT_DETAILS_SUCCESS,
        data,
        scheduleId: action.scheduleId,
      });
    }
  } catch (error) {
    let payload = error.response.data;
    yield put({ type: actionTypes.GET_PAYMENT_DETAILS_ERROR, payload });
  }
}

function* saveInvoiceNote(action) {
  try {
    let { payload } = action;

    const response = yield axios({
      method: 'post',
      url: `/deal/${payload.dealId}/payment/${payload.paymentId}/note`,
      data: { note: payload.note }
    })

    if (response?.status === 200) {
      const { data } = response.data;

      yield put({
        type: actionTypes.CREATE_INVOICE_NOTE_SUCCESS,
        data,
        scheduleId: action.scheduleId,
      });
    }
  } catch (error) {
    let payload = error.response.data;
    yield put({ type: actionTypes.CREATE_INVOICE_NOTE_ERROR, payload });
  }
}


function* updateInvoiceTheme(action) {
  try {
    let { payload } = action;

    const response = yield axios({
      method: 'post',
      url: `/deal/${payload.dealId}/payment/${payload.paymentId}/theme`,
      data: { theme: payload.theme }
    })

    if (response?.status === 200) {
      const { data } = response.data;

      yield put({
        type: actionTypes.UPDATE_INVOICE_THEME_SUCCESS,
        data,
        scheduleId: action.scheduleId,
      });
    }
  } catch (error) {
    let payload = error.response.data;
    yield put({ type: actionTypes.UPDATE_INVOICE_THEME_ERROR, payload });
  }
}

function* sendEmail(action) {
  try {
    let { payload } = action;

    const response = yield axios({
      method: 'post',
      url: `/deal/${payload.dealId}/payment/${payload.scheduleId}/email`
    })

    if (response?.status === 200) {
      const { data } = response.data;

      yield put({
        type: actionTypes.SEND_PAYMENT_INVOICE_EMAIL_SUCCESS,
        data,
        scheduleId: action.scheduleId,
      });
    }
  } catch (error) {
    // let payload = error.response.data;
    console.log(error)
    yield put({ type: actionTypes.SEND_PAYMENT_INVOICE_EMAIL_ERROR });
  }
}

function* getSalesAccounts() {
  try {
    const response = yield axios({
      method: 'get',
      url: `/dealer/xero/products`
    })

    if (response?.status === 200) {
      const { data } = response.data;

      yield put({
        type: actionTypes.GET_SALES_ACCOUNTS_SUCCESS,
        data
      });
    }
  } catch (error) {
    // let payload = error.response.data;
    console.log(error)
    yield put({ type: actionTypes.GET_SALES_ACCOUNTS_ERROR });
  }
}
function* getDealStatisticsRequest(action) {
  try {
    let params = action.data;
    const response = yield axios.get(`${API_URL}/deal/statistics`, {
      params: params
    });
    if (response?.status === 200) {
      const data = response?.data?.data;
      yield put({
        type: actionTypes.GET_DEAL_STATISTICS_SUCCESS,
        data
      });
    }
  } catch (error) {
    let payload = error.response.data;
    yield put({ type: actionTypes.GET_DEAL_STATISTICS_ERROR, payload });
  }
}
function* getTaxes() {
  try {

    const response = yield axios({
      method: 'get',
      url: `/dealer/xero/taxes`
    })

    if (response?.status === 200) {
      const { data } = response.data;

      yield put({
        type: actionTypes.GET_TAXES_SUCCESS,
        data
      });
    }
  } catch (error) {
    // let payload = error.response.data;
    yield put({ type: actionTypes.GET_TAXES_ERROR });
  }
}

function* postUpdateInvoicePayement(action) {
  try {
    const response = yield call(updatePayment, action.payload);

    if (response?.status === 200) {
      const { data } = response.data;

      yield put({
        type: actionTypes.UPDATE_INVOICE_SUCCESS,
        data
      });
    }
  } catch (error) {
    // let payload = error.response.data;
    yield put({ type: actionTypes.UPDATE_INVOICE_ERROR, message: error.response.data?.message ?? null });
  }
}

function* getBusinessActivityRequest() {
  try {

    const response = yield axios({
      method: 'get',
      url: `${API_URL}/business-activity`,
    })

    if (response?.status === 200) {
      const { data } = response.data;

      yield put({
        type: actionTypes.GET_BUSINESS_ACTIVITY_SUCCESS,
        data
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.GET_BUSINESS_ACTIVITY_ERROR });
  }
}
function* getCompanyTypes() {
  try {

    const response = yield axios({
      method: 'get',
      url: `${API_URL}/company-type`,
    })

    if (response?.status === 200) {
      const { data } = response.data;

      yield put({
        type: actionTypes.GET_COMPANY_TYPE_SUCCESS,
        data
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.GET_COMPANY_TYPE_ERROR });
  }
}
function* uploadDealsToGoogleSheets(action) {
  try {
    const response = yield axios.post(`${API_URL}/upload-deals-to-google`,{
      finished_payment: action.payload.finished_payment,
    });
    if (response?.status === 200) {
      yield put({ type: actionTypes.UPLOAD_DEALS_TO_GOOGLE_SHEETS_SUCCESS });
    }
  } catch (error) {
    yield put({ type: actionTypes.UPLOAD_DEALS_TO_GOOGLE_SHEETS_ERROR, });
  }
}
export default function* watcherSaga() {
  yield takeLatest(actionTypes.GET_PAYMENT_DETAILS_REQUEST, getPaymentData);
  yield takeLatest(actionTypes.CREATE_INVOICE_NOTE_REQUEST, saveInvoiceNote);
  yield takeLatest(actionTypes.UPDATE_INVOICE_THEME_REQUEST, updateInvoiceTheme);
  yield takeLatest(actionTypes.SEND_PAYMENT_INVOICE_EMAIL_REQUEST, sendEmail);
  yield takeLatest(actionTypes.GET_SALES_ACCOUNTS_REQUEST, getSalesAccounts);
  yield takeLatest(actionTypes.UPDATE_INVOICE_REQUEST, postUpdateInvoicePayement);
  yield takeLatest(actionTypes.GET_TAXES_REQUEST, getTaxes);
  yield takeLatest(actionTypes.GET_DEAL_STATISTICS_REQUEST, getDealStatisticsRequest);
  yield takeLatest(actionTypes.GET_BUSINESS_ACTIVITY_REQUEST, getBusinessActivityRequest);
  yield takeLatest(actionTypes.GET_COMPANY_TYPE_REQUEST, getCompanyTypes);
  yield takeLatest(actionTypes.UPLOAD_DEALS_TO_GOOGLE_SHEETS_REQUEST, uploadDealsToGoogleSheets);
}
